import { Component } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true,
})
export class FooterComponent {
    currYear: number = new Date().getFullYear();
}
